import React, { useState, useRef, useEffect } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaTimesCircle, FaLock } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "../styles/bookdescription.css";
import { motion } from "framer-motion";

// const ARTICLE_IMAGES = Array.from({ length: 15 }, (_, i) =>
//   require(`../Asset/poorval${i + 11}.jpg`)
// );

export default function BookDetails() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { productId } = useParams(); // URL parameter from App.js route
  const navigate = useNavigate();
  const toastLock = useRef(false);
  // const TITLE_LIMIT = 30;

  const resolveImageUrl = (path) => {
    if (!path) return "/no-image.png"; // optional fallback
    if (path.startsWith("http")) return path;
    return `${API_BASE_URL}${path}`;
  };

  // Main Book Data State
  const [pageLoading, setPageLoading] = useState(true);
  const [bookDetails, setBookDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [recentBooks, setRecentBooks] = useState([]);
  const [loadingBooks, setLoadingBooks] = useState(true);

  // UI States
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [toastMessage, setToastMessage] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [zoom, setZoom] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [qty, setQty] = useState(1);

  // Page loader
  const PageLoader = () => {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "#ffffff",
          zIndex: 99999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          className="spinner-border"
          role="status"
          style={{ width: "3.5rem", height: "3.5rem", color: "#f64a1aff" }}
        />
        <p className="mt-3 fw-semibold">Loading Book Description...</p>
      </div>
    );
  };

  useEffect(() => {
    if (!loading && !loadingBooks && !categoriesLoading) {
      setPageLoading(false);
    }
  }, [loading, loadingBooks, categoriesLoading]);

  // 1. FETCH BOOK DETAILS FROM API
  useEffect(() => {
    const fetchBookData = async () => {
      if (!productId) return;

      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}book_detail.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ p_id: productId }),
        });
        const data = await response.json();
        console.log("Book Detail API response:", data);

        if (data.head.code === 200) {
          const b = data.body;
          // Mapping Postman response fields to component state
          setBookDetails({
            id: productId,
            mp_id: b.mp_id,
            sp_id: b.sp_id,
            code: b.product_code,
            title: b.product_name,
            author: b.author_name,
            publishDate: b.publish_date,
            price: b.product_onlinerate,
            mrp: b.product_mrprate,
            tax: b.product_tax,
            stock: b.product_stock,
            shortDesc: b.short_desc,
            fullDesc: b.full_desc,
            // Filtering and collecting Base64 images from Postman body
            images: [
              b.product_image1,
              b.product_image2,
              b.product_image3,
              b.product_image4,
            ]
              .filter((img) => img && img.trim() !== "")
              .map((img) => resolveImageUrl(img)),
          });
          setSelectedIndex(0); // Reset to first image on new book load
        }
      } catch (err) {
        console.error("Error fetching book details:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBookData();
  }, [API_BASE_URL, productId]);

  // 2. FETCH POPULAR CATEGORIES
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}books_subcategory_list.php`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          },
        );
        const data = await response.json();
        if (data.head.code === 200) {
          const sorted = data.body
            .sort(
              (a, b) =>
                (Number(a.subcategory_rank) || 0) -
                (Number(b.subcategory_rank) || 0),
            )
            .map((item) => ({
              name: item.subcategory_name,
              img: item.subcategory_image,
              mp_id: item.mp_id,
              sp_id: item.sp_id,
            }));
          setCategories(sorted);
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      } finally {
        setCategoriesLoading(false);
      }
    };
    fetchCategories();
  }, [API_BASE_URL]);

  // Recent books

  useEffect(() => {
    fetch(`${API_BASE_URL}recent_books_list.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.head?.code === 200) {
          setRecentBooks(data.body);
        } else {
          setRecentBooks([]);
        }
        setLoadingBooks(false);
      })
      .catch((err) => {
        console.error("Recent books API error:", err);
        setLoadingBooks(false);
      });
  }, [API_BASE_URL]);

  // const addToCart = () => {
  //   if (!bookDetails) return;

  //   let cart = JSON.parse(localStorage.getItem("cart")) || [];

  //   const cartId = `book-${bookDetails.id}-${bookDetails.mp_id}-${bookDetails.sp_id}`;

  //   const existsIndex = cart.findIndex((item) => item.id === cartId);

  //   if (toastLock.current) return;
  //   toastLock.current = true;

  //   if (existsIndex === -1) {
  //     cart.push({
  //       id: cartId, // ✅ consistent ID
  //       code: bookDetails.code,
  //       mpid: bookDetails.mp_id,
  //       spid: bookDetails.sp_id,
  //       product_id: bookDetails.id,
  //       title: bookDetails.title,
  //       image: bookDetails.images[0],
  //       price: bookDetails.price,
  //       quantity: qty,
  //       mrp: bookDetails.mrp,
  //       tax: bookDetails.tax,
  //       author: bookDetails.author,
  //       type: "Hardcopy",
  //       plan: "Single",
  //     });
  //     setToastMessage("Book added to cart!");
  //   } else {
  //     cart[existsIndex].quantity += qty;
  //     setToastMessage("Cart updated!");
  //   }

  //   localStorage.setItem("cart", JSON.stringify(cart));
  //   console.log("Cart updated:", cart);
  //   window.dispatchEvent(new Event("cartUpdated"));

  //   setTimeout(() => {
  //     setToastMessage("");
  //     toastLock.current = false;
  //   }, 2000);
  // };

  const addToCart = () => {
    if (!bookDetails) return;

    let cart = JSON.parse(localStorage.getItem("cart")) || [];
    const cartId = `book-${bookDetails.id}-${bookDetails.mp_id}-${bookDetails.sp_id}`;
    const existsIndex = cart.findIndex((item) => item.id === cartId);

    const stockLimit = Number(bookDetails.stock);

    if (toastLock.current) return;

    // VALIDATION LOGIC
    if (existsIndex !== -1) {
      // Check if (Current Cart Qty + New Qty) exceeds Stock
      if (cart[existsIndex].quantity + qty > stockLimit) {
        setToastMessage(`Only ${stockLimit} items available in stock!`);
        toastLock.current = true;
        setTimeout(() => {
          setToastMessage("");
          toastLock.current = false;
        }, 2000);
        return;
      }

      cart[existsIndex].quantity += qty;
      setToastMessage("Cart updated!");
    } else {
      // Initial check for the first time adding to cart
      if (qty > stockLimit) {
        setToastMessage(`Only ${stockLimit} items available!`);
        toastLock.current = true;
        setTimeout(() => {
          setToastMessage("");
          toastLock.current = false;
        }, 2000);
        return;
      }

      cart.push({
        id: cartId,
        code: bookDetails.code,
        mpid: bookDetails.mp_id,
        spid: bookDetails.sp_id,
        product_id: bookDetails.id,
        title: bookDetails.title,
        image: bookDetails.images[0],
        price: bookDetails.price,
        quantity: qty,
        mrp: bookDetails.mrp,
        tax: bookDetails.tax,
        author: bookDetails.author,
        type: "Hardcopy",
        plan: "Single",
        availableStock: stockLimit, // ✅ Sending stock value to cart
      });
      setToastMessage("Book added to cart!");
    }

    toastLock.current = true;
    localStorage.setItem("cart", JSON.stringify(cart));
    window.dispatchEvent(new Event("cartUpdated"));

    setTimeout(() => {
      setToastMessage("");
      toastLock.current = false;
    }, 2000);
  };

  const handleCategoryClick = ({ mp_id, sp_id }) => {
    navigate(`/articles?mp_id=${mp_id}&sp_id=${sp_id}`);
  };

  // Prevent "Cannot read properties of undefined (reading 'map')"
  // if (loading) {
  //   return (
  //     <div
  //       className="d-flex justify-content-center align-items-center"
  //       style={{ minHeight: "80vh" }}
  //     >
  //       <div className="spinner-border text-primary" role="status">
  //         <span className="visually-hidden">Loading...</span>
  //       </div>
  //     </div>
  //   );
  // }

  if (pageLoading) {
    return <PageLoader />;
  }

  if (!bookDetails) {
    return (
      <div className="container text-center mt-5">
        <h4>No Product Found</h4>
        <button className="btn btn-primary mt-3" onClick={() => navigate("/")}>
          Back to Home
        </button>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return "";
    // Splits "2025-12-16" into ["2025", "12", "16"]
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="container-fluid">
      <div className="book-description-container">
        {/* {toastMessage && (
          <div
            className="position-fixed text-white px-3 py-2 rounded shadow"
            style={{ 
                position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                background: 'rgba(0, 0, 0, 0.8)', color: 'white', padding: '10px 20px', borderRadius: '8px', zIndex: 1000 
            }}
          >
            {toastMessage}
          </div>
        )} */}

        {toastMessage && (
          <motion.div
            initial={{ opacity: 0, scale: 0.7, y: -20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            className="toast-center"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "#1d8535",
              color: "#ffffff",
              padding: "1rem 1.5rem",
              borderRadius: "10px",
              zIndex: 9999,
              fontWeight: "bold",
              fontSize: "1rem",
              animation: "fadeInOut 3s forwards",
              textAlign: "center",
            }}
          >
            {toastMessage}
          </motion.div>
        )}

        <div className="row">
          {/* LEFT SECTION - IMAGES */}
          <div className="col-12 col-lg-5 col-md-6 text-center">
            <div className="d-flex">
              <div className="d-flex">
                {/* Thumbnails */}
                <div className="d-flex flex-column align-items-center me-4">
                  <button
                    className="btn btn-light p-1 mb-2"
                    onClick={() => setSelectedIndex((p) => (p > 0 ? p - 1 : p))}
                  >
                    ▲
                  </button>
                  <div
                    className="booksimage"
                    style={{
                      height: "auto",
                      overflowY: "auto",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    {bookDetails.images.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt="thumb"
                        className={`border rounded ${
                          selectedIndex === index ? "border-danger" : ""
                        }`}
                        style={{
                          width: "60px",
                          height: "80px",
                          objectFit: "cover",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedIndex(index)}
                      />
                    ))}
                  </div>
                  <button
                    className="btn btn-light p-1 mt-2"
                    onClick={() =>
                      setSelectedIndex((p) =>
                        p < bookDetails.images.length - 1 ? p + 1 : p,
                      )
                    }
                  >
                    ▼
                  </button>
                </div>

                {/* Main Image with Zoom */}
                <div
                  className="magnifier flex-grow-1"
                  style={{
                    width: "90%",
                    height: "auto",
                    position: "relative",
                    overflow: "hidden",
                    cursor: zoom ? "zoom-out" : "zoom-in",
                    backgroundColor: "#fff",
                  }}
                  onMouseEnter={() => setZoom(true)}
                  onMouseLeave={() => setZoom(false)}
                  onMouseMove={(e) => {
                    const rect = e.currentTarget.getBoundingClientRect();
                    setPosition({
                      x: ((e.clientX - rect.left) / rect.width) * 100,
                      y: ((e.clientY - rect.top) / rect.height) * 100,
                    });
                  }}
                >
                  {/* Base Image (always visible) */}
                  <img
                    src={bookDetails.images[selectedIndex]}
                    alt="cover"
                    style={{
                      width: "90%",
                      height: "90%",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />

                  {/* Zoom Overlay */}
                  {zoom && (
                    <div
                      style={{
                        position: "absolute",
                        inset: 0,
                        backgroundImage: `url(${bookDetails.images[selectedIndex]})`,
                        backgroundSize: "250% 250%",
                        backgroundPosition: `${position.x}% ${position.y}%`,
                        backgroundRepeat: "no-repeat",
                        pointerEvents: "none",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SECTION - DETAILS */}
          <div className="col-12 col-lg-7 col-md-6 text-start mt-3 mt-md-0">
            <h3 className="mb-3">{bookDetails.title}</h3>
            <div className="d-flex flex-wrap">
              <p className="text-muted">
                Author: <strong>{bookDetails.author}</strong> | Published:{" "}
                <strong>{formatDate(bookDetails.publishDate)}</strong>
                <span
                  onClick={() => {
                    if (navigator.share) {
                      navigator.share({
                        title: bookDetails.title,

                        text: `Check out this book: ${bookDetails.title}`,

                        url: window.location.href,
                      });
                    } else {
                      alert("Sharing not supported on this device.");
                    }
                  }}
                  className="bi bi-share-fill mx-2"
                  style={{ cursor: "pointer", fontSize: "1.1rem" }}
                ></span>
              </p>
            </div>

            <p className="text-danger mb-2 d-inline-block">
              {Number(bookDetails.mrp) > 0 && (
                <span className="text-danger text-decoration-line-through me-3">
                  <strong>MRP:</strong> ₹{bookDetails.mrp}
                </span>
              )}
            </p>
            <p className="text-success d-inline fw-bold mb-2">
              Price: ₹ {bookDetails.price}
            </p>

            <p className="fw-bold mb-3 mt-3">
              Availability:{" "}
              {Number(bookDetails.stock) === 0 ? (
                <span className="text-danger">Out of Stock</span>
              ) : (
                <span className="text-success">
                  (In Stock)
                  {Number(bookDetails.stock) < 5 && (
                    <span className="text-danger ms-2">
                      - Hurry Up! Only {bookDetails.stock} remaining
                    </span>
                  )}
                </span>
              )}
            </p>

            <div className="d-flex flex-wrap align-items-center mb-3">
              <span className="me-2">Qty:</span>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => qty > 1 && setQty(qty - 1)}
              >
                -
              </button>
              <input
                type="text"
                value={qty}
                className="form-control text-center mx-2"
                style={{ width: "50px" }}
                readOnly
              />
              <button
                className="btn btn-success btn-sm me-2"
                onClick={() => setQty(qty + 1)}
                disabled={qty >= Number(bookDetails.stock)}
              >
                +
              </button>
              <button
                className="btn btn-warning fw-semibold px-2"
                onClick={addToCart}
                disabled={Number(bookDetails.stock) <= 0}
              >
                {Number(bookDetails.stock) <= 0
                  ? "Out of Stock"
                  : "ADD TO CART"}
              </button>
            </div>

            <p className="fw-bold">Short Description:</p>
            <p
              className="text-muted shortdesc"
              style={{ paddingRight: "50px" }}
            >
              {bookDetails.shortDesc}
            </p>

            <div className="d-flex gap-4 mt-4 flex-wrap justify-content-evenly">
              <div className="d-flex align-items-center gap-2">
                <FaTimesCircle color="#ff4d4f" />{" "}
                <span>Cancel within Shipment</span>
              </div>
              <div className="d-flex align-items-center gap-2">
                <FaLock color="#52c41a" /> <span>Secure Payment</span>
              </div>
            </div>
          </div>
        </div>

        {/* FULL DESCRIPTION */}
        <div className="mt-5 mx-2 text-start">
          <h5 className="border-bottom pb-2 mb-3">PRODUCT DESCRIPTION</h5>
          <div
            className="text-muted fulldesc"
            dangerouslySetInnerHTML={{ __html: bookDetails.fullDesc }}
          />
        </div>

        {/* RELATED SWIPERS (RECENT BOOKS) */}
        {/* RECENT BOOKS */}
        <section className="py-3">
          <div className="container-fluid">
            <div className="d-flex justify-content-between mb-3">
              <h4>Recent Books</h4>
              <Link
                className="viewalllinks"
                to="/articles"
                onClick={() => window.scrollTo(0, 0)}
              >
                View All
              </Link>
            </div>

            {loadingBooks ? (
              <div className="text-center py-4">Loading books...</div>
            ) : recentBooks.length === 0 ? (
              <div className="text-center py-4">No books available</div>
            ) : (
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation
                loop={recentBooks.length > 3}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                spaceBetween={15}
                slidesPerView={1}
                breakpoints={{
                  375: { slidesPerView: 2 },
                  425: { slidesPerView: 2 },
                  576: { slidesPerView: 3 },
                  768: { slidesPerView: 4 },
                  1024: { slidesPerView: 5 },
                  1200: { slidesPerView: 6 },
                }}
              >
                {recentBooks.map((book) => (
                  <SwiperSlide key={book.product_id}>
                    <div className="card shadow-sm p-2 book-card">
                      <img
                        src={book.product_url}
                        className="book-img swiper-book-img"
                        alt={book.mpname}
                        style={{ height: "220px", objectFit: "contain" }}
                        onClick={() => {
                          window.scrollTo(0, 0);
                          navigate(
                            `/bookdescription/${
                              book.product_id || book.id
                            }?mp_id=${book.mp_id}&sp_id=${book.sp_id}`,
                          );
                        }}
                      />
                      <p className="mt-2 text-center fw-semibold">
                        {book.product_name.length > 15
                          ? `${book.product_name.slice(0, 15)}`
                          : book.product_name}

                        {book.product_name.length > 15 && (
                          <span
                            className="ms-1 text-dark"
                            style={{ cursor: "pointer", fontSize: "0.85rem" }}
                            onClick={() => {
                              window.scrollTo(0, 0);
                              navigate(
                                `/bookdescription/${book.product_id}?mp_id=${book.mp_id}&sp_id=${book.sp_id}`,
                              );
                            }}
                          >
                            ...
                          </span>
                        )}
                      </p>

                      <p className="text-center">
                        <span className="fw-bold text-success me-2">
                          ₹{book.online_rate}
                        </span>
                        {Number(book.mrp_rate) > 0 && (
                          <span className="text-danger text-decoration-line-through">
                            ₹{book.mrp_rate}
                          </span>
                        )}
                      </p>
                      {/* <button
                              className="add-to-cart-btn1 w-100 position-relative"
                              onClick={() => addToCart(book)}
                            >
                              <span className="cart-icon-wrapper1">
                                <FaShoppingCart size={16} />
                              </span>
                              <span className="cart-btn-text1">Add to Cart</span>
                            </button> */}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </section>

        {/* POPULAR CATEGORIES */}
        <section className="py-3">
          <div className="container-fluid">
            <h4>Book Categories</h4>
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation
              autoplay={{ delay: 2500 }}
              spaceBetween={15}
              slidesPerView={2}
              breakpoints={{
                425: { slidesPerView: 3 },
                576: { slidesPerView: 4 },
                768: { slidesPerView: 5 },
                992: { slidesPerView: 6 },
                1200: { slidesPerView: 8 },
              }}
            >
              {categoriesLoading ? (
                <p>Loading...</p>
              ) : (
                categories.map((cat, idx) => (
                  <SwiperSlide key={idx}>
                    <div
                      className="category-box"
                      style={{ backgroundImage: `url(${cat.img})` }}
                      onClick={() => {
                        window.scrollTo(0, 0);
                        handleCategoryClick({
                          mp_id: cat.mp_id,
                          sp_id: cat.sp_id,
                        });
                      }}
                    >
                      <div className="overlay">
                        <h6 className="text-center">{cat.name}</h6>
                      </div>
                    </div>
                  </SwiperSlide>
                ))
              )}
            </Swiper>
          </div>
        </section>
      </div>
    </div>
  );
}
